import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { IDataImportService } from "services/DataImportService";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const dataImportService = () => container.get<IDataImportService>(SERVICE_TYPES.DataImportService);

// AcquireLock is 200 even when another user holds a live lock — denial is in the payload.
export const acquireSubmissionLock = createAsyncThunk(
  "DataImport/AcquireSubmissionLock",
  async (submissionID: string) => {
    try {
      const lock = await dataImportService().acquireLock(submissionID);
      if (lock.isHeldByCurrentUser !== true) {
        toast.error(`${lock.heldByUserName ?? "Another user"} is currently editing this submission`);
      }
      return {
        heldByCurrentUser: lock.isHeldByCurrentUser === true,
        heldByUserName: lock.heldByUserName ?? undefined,
      };
    } catch (error) {
      toast.error("Failed to open the submission for editing");
      throw error;
    }
  }
);

// Fire-and-forget on wizard unmount. The condition skips the round-trip when the lock was
// never ours; no toasts — ReleaseLock never fails meaningfully and the user is already gone.
export const releaseSubmissionLock = createAsyncThunk(
  "DataImport/ReleaseSubmissionLock",
  async (submissionID: string) => {
    await dataImportService().releaseLock(submissionID);
  },
  {
    condition: (_submissionID, { getState }) =>
      (getState() as RootState).dataImportSubmissionLock.LockStatus === "held",
  }
);
